<template>
  <div class="box">
    <div class="study-ul" v-if="list2.length > 0">
      <div class="study-li" v-for="(item, index) in list2" :key="index" @click="gotoCourseDetails(item)">
        <div class="study-video" v-if="item.information">
          <img v-if="item.information.image != undefined" :src="item.information.image.url" />
          <img v-else src="@/assets/images/logo-img.png" alt="">
          <div v-if="item.information.courseDurationFormat != undefined" class="study-duration">{{ item.information.courseDurationFormat }}</div>
        </div>
        <div class="study-text" v-if="item.information">
          <div class="study-title" v-if="item.information.title != undefined">{{ item.information.title }}</div>
          <div class="study-time">
            <div class="study-left" v-if="item.information.updateTimeFormat != undefined">{{ item.information.updateTimeFormat }}</div>
            <div class="study-right">观看至{{ item.progress }}%</div>
          </div>
        </div>
      </div>
    </div>
    <empty class="empty-margin" v-if="list2.length <= 0"></empty>
    <el-pagination class="paging" background :current-page="page.number" :page-sizes="[10, 20, 30, 40]" :page-size="page.limit" layout="prev, pager, next, sizes" :total="page.total"
      @size-change="sizeChange" @current-change="currentChange" @prev-click="prevClick" @next-click="nextClick" />
  </div>
</template>

<script>
import empty from "@/components/empty/index";
export default {
  name: "InProgress",
  components: { empty },
  props: {
    list2: {
      type: Array,
      default: [{
        information: {
          courseDurationFormat: ''
        }
      }]
    },
    page: {
      type: Object,
      default: {}
    },
  },
  methods: {
    // 判断当前课程是否已经观看
    gotoCourseDetails(value) {
      this.$router.push({ path: `/CourseDetails/${value.information.id}` }); // 动态路由传递课程 id
    },
    sizeChange(value) {
      this.$emit('sizeChange', value)
    },
    currentChange(value) {
      this.$emit('currentChange', value)
    },
    prevClick(value) {
      this.$emit('currentChange', value)
    },
    nextClick(value) {
      this.$emit('currentChange', value)
    },
  }
};
</script>

<style scoped lang="less">
.study-li {
  cursor: pointer;
}
/deep/.el-input__inner {
  height: 32px;
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pagination button {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pager li {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  border-right: 2px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #BD181E !important;
  color: rgba(255, 255, 255, 0.65) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/PersonalCenter/components/StudyList.vue